// Rodolfo Rivas
// 2017
//*************************************************************//
//                                                             //
//    ╔═╗┌─┐┌┬┐┌─┐┌─┐┌┐┌┌─┐┌┐┌┌┬┐┌─┐  ┬ ┬┌─┐┬ ┬┌─┐┬─┐┬┌─┐      //
//    ║  │ ││││├─┘│ ││││├┤ │││ │ ├┤   │ │└─┐│ │├─┤├┬┘││ │      //
//    ╚═╝└─┘┴ ┴┴  └─┘┘└┘└─┘┘└┘ ┴ └─┘  └─┘└─┘└─┘┴ ┴┴└─┴└─┘      //
//                                                             //
//*************************************************************//


import {AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {UtilConfig} from "../../../../autenticacion/servicios/UtilConfig";
import {LayoutService} from "../../../recursos/servicio/layout.service";
import {Subscription} from "rxjs/Subscription";
import * as moment from 'moment';
import {Router} from "@angular/router";
// d3 and nvd3 should be included somewhere
import 'd3';
import 'nvd3';
import {ConsumerService} from "../../../recursos/servicio/consumer.service";
import {WebServices} from "../../../recursos/modelo/consumerModel/web-services.enum";

declare var $: any;


export interface PeriodicElement {
    name: string;
    position: number;
    weight: number;
    symbol: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
    {position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H'},
    {position: 2, name: 'Helium', weight: 4.0026, symbol: 'He'},
    {position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li'},
    {position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be'},
    {position: 5, name: 'Boron', weight: 10.811, symbol: 'B'},
    {position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C'},
    {position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N'},
    {position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O'},
    {position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F'},
    {position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne'}
];

@Component({
    selector: 'app-bienvenido',
    templateUrl: './view/bienvenido.component.html',
    styleUrls: ['./css/bienvenido.component.css'],
    providers: [ConsumerService]
})
export class BienvenidoComponent implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    public usuarioSession: any;
    loadingBackground = true;
    displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
    dataSource = new MatTableDataSource(ELEMENT_DATA);

//        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
//        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
//        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─
    mesAnio;
    subscription: Subscription;
    help_view: number = 0;
    DATA_DONUT = null;
    DATA_DONUT_SOLES = null;
    DATA_DONUT_DOLARES = null;
    afiliado;
    loadingConsultas = [
        {
            modulo: "Cargando Estadisticas",
            cargando: false
        },
        {
            modulo: "Cargando Afiliados",
            cargando: false
        }
    ];
    OPTION = {
        chart: {
            type: 'multiBarChart',
            height: 250,
            margin: {
                top: 90,
                right: 20,
                bottom: 45,
                left: 65
            },
            clipEdge: true,
            //staggerLabels: true,
            duration: 500,
            stacked: false,
            xAxis: {
                axisLabel: '',
                showMaxMin: true
            },
            yAxis: {
                axisLabel: 'Transacciones',
                axisLabelDistance: 0
            }
        }
    };
    affiliates: any[] = [];

    constructor(private layoutService: LayoutService,
                private router: Router,
                private consumer: ConsumerService,
                private jwtutil: UtilConfig) {
        this.usuarioSession = jwtutil.getCurrentUser();
        this.subscription = this.layoutService.getUsuarioSession().subscribe(usuarioSession => {
            this.usuarioSession = usuarioSession;
        });
        moment.locale('es-es');
        this.mesAnio = moment().format("MMMM/YYYY");
        this.afiliado = this.usuarioSession.customer.ruc;

    }

    @HostListener('window:keyup.escape', ['$event'])
    keyEvent(event: KeyboardEvent) {
        $(".help_div").removeClass("open");
    }

    ngOnInit() {
        //this.getAffiliates(this.usuarioSession.customer.id);
        //this.getStadistic(this.usuarioSession.customer.ruc);
    }


    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    getStadistic(rucConsulta) {
        this.loadingConsultas[0].cargando = true;
        this.consumer.post<any>(WebServices.URL_ESTADISTICAS_CUSTOMER, {customer: {ruc: parseInt(rucConsulta)}})
            .subscribe((result) => {
                if (this.usuarioSession.customer.type != 'CANAL') {
                    this.usuarioSession.customer.goodReqCounter = result["customer"].goodReqCounter;
                    this.usuarioSession.customer.failReqCounter = result["customer"].failReqCounter;
                    this.DATA_DONUT = [];
                    this.DATA_DONUT.push({key: "Aceptados", y: this.usuarioSession.customer.goodReqCounter});
                    this.DATA_DONUT.push({key: "Rechazados", y: this.usuarioSession.customer.failReqCounter});
                } else {
                    this.DATA_DONUT_DOLARES = [{
                        "key": "DOLARES",
                        "values": [{
                            "x": "CANTIDAD",
                            "y": result["customer"].cantUSD
                        }]
                    }, {
                        "key": "SOLES",
                        "values": [{
                            "x": "CANTIDAD",
                            "y": result["customer"].cantSOLES
                        }]
                    }];

                    this.DATA_DONUT_SOLES = [{
                        "key": "DOLARES",
                        "values": [{
                            "x": "MONTO",
                            "y": result["customer"].montoUSD
                        }]
                    }, {
                        "key": "SOLES",
                        "values": [{
                            "x": "MONTO",
                            "y": result["customer"].montoSOLES
                        }]
                    }];

                }
                this.loadingConsultas[0].cargando = false;
            }, err => {
                this.loadingConsultas[0].cargando = false;
                this.jwtutil.abrirModalErrorParaServicios(err, "No se pudo cargar estadisticas del emisor", this.router)
            });
    }


    getAffiliates(rucConsulta) {
        this.loadingConsultas[1].cargando = true;
        this.consumer.post<any>(WebServices.URL_GET_AFFILIATES, {customer: {id: rucConsulta}})
            .subscribe((result) => {
                this.affiliates = [];
                this.affiliates.push({label: "TODOS", value: this.usuarioSession.customer.ruc});

                if (result["affiliates"] != null) {
                    $.each(result["affiliates"], (pos, item) => {
                        this.affiliates.push({label: item.nombre, value: item.ruc})
                    });
                }
                this.loadingConsultas[1].cargando = false;
            }, err => {
                this.loadingConsultas[1].cargando = false;
                this.jwtutil.abrirModalErrorParaServicios(err, "No se pudo cargar estadisticas del emisor", this.router)
            });
    }

    cambiarAfiliado() {
        this.getStadistic(this.afiliado);
    }

//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┌┐┌┌┬┐┌─┐┬  ┬  ┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  ├─┘├─┤│││ │ ├─┤│  │  ├─┤
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  ┴  ┴ ┴┘└┘ ┴ ┴ ┴┴─┘┴─┘┴ ┴


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘

}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/home/bienvenido/bienvenido.component.ts